import { FormattedMessage, useIntl } from 'react-intl'
import {
  MoovyContainerContent,
  MoovyContainerHeader,
  MoovyTab,
} from '../../components'
import MoovyContainer from '../../components/moovyContainer/moovyContainer'
import EndedParkingEvents from './endedParkingEvents'
import OngoingParkingEvents from './ongoingParkingEvents'

const ParkingEvents = () => {
  const intl = useIntl()
  const formattedMessage = (id: string) => intl.formatMessage({ id })
  const tabPanels = [<OngoingParkingEvents />, <EndedParkingEvents />]
  return (
    <MoovyContainer>
      <MoovyContainerHeader>
        <FormattedMessage id="common.app.name" />
      </MoovyContainerHeader>
      <MoovyContainerContent>
        <MoovyTab
          tabKey="parkingEventsTab"
          tabHeaders={[
            formattedMessage('page.parkingEvents.ongoing'),
            formattedMessage('page.parkingEvents.ended'),
          ]}
          tabPanels={tabPanels}
        />
      </MoovyContainerContent>
    </MoovyContainer>
  )
}

export default ParkingEvents
